import React from "react";

export const InstagramCircleFilledIcon = (props) => {
  return (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y="0.818359" width="40" height="40" rx="20" fill="#18428E" />
      <path
        d="M25 10.8184H15C12.2386 10.8184 10 13.0569 10 15.8184V25.8184C10 28.5798 12.2386 30.8184 15 30.8184H25C27.7614 30.8184 30 28.5798 30 25.8184V15.8184C30 13.0569 27.7614 10.8184 25 10.8184Z"
        fill="white"
      />
      <path
        d="M24.0002 20.1884C24.1236 21.0207 23.9815 21.8706 23.594 22.6174C23.2065 23.3642 22.5933 23.9698 21.8418 24.3481C21.0903 24.7264 20.2386 24.858 19.408 24.7243C18.5773 24.5907 17.81 24.1985 17.215 23.6036C16.6201 23.0087 16.2279 22.2413 16.0943 21.4106C15.9606 20.58 16.0923 19.7283 16.4705 18.9768C16.8488 18.2253 17.4544 17.6122 18.2012 17.2247C18.948 16.8372 19.7979 16.695 20.6302 16.8184C21.4791 16.9443 22.265 17.3399 22.8719 17.9467C23.4787 18.5536 23.8743 19.3395 24.0002 20.1884Z"
        stroke="#18428E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 15.3184H25.51"
        stroke="#18428E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
